import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import MobilePage from "mobile/components/MobilePage";
import MobileSearchOverlay from "mobile/components/MobileSearchOverlay";

export default function SearchMobile() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  const closeSearch = () => {
    setOpen(false);
    navigate("/m/dashboard", { replace: true });
  };

  return (
    <MobilePage title="Find" subtitle="Search records and ask the assistant" onBack={() => navigate("/m/dashboard")}>
      <Box sx={{ py: 4, textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          Search is open.
        </Typography>
      </Box>
      <MobileSearchOverlay open={open} onClose={closeSearch} onNavigate={(to) => navigate(to)} />
    </MobilePage>
  );
}
